import React, { useRef, useEffect, useState } from 'react';
import generateBrandedQR from '../../utils/generateBrandedQR';

const appUrl = () => {
  try {
    const { DB } = require('../../data/database');
    const cfg = DB.get('appConfig');
    if (cfg && typeof cfg === 'object' && !Array.isArray(cfg) && cfg.site_url) return cfg.site_url.replace(/"/g, '');
  } catch {}
  return window.location.origin;
};

function QRBox({ sku }) {
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    if (sku) {
      generateBrandedQR(`${appUrl()}/?u=${sku}`, { size: 280 }).then(setImgSrc).catch(() => {});
    }
  }, [sku]);

  return (
    <div className="qr-box">
      {imgSrc ? <img src={imgSrc} alt="QR" style={{ width: 140, height: 140, imageRendering: 'pixelated' }} /> : <div style={{ width: 140, height: 140 }} />}
      <div className="qr-label">{sku}</div>
    </div>
  );
}

export const printQR = async (sku, name) => {
  const url = `${appUrl()}/?u=${sku}`;
  try {
    const dataUrl = await generateBrandedQR(url, { size: 472 });
    let iframe = document.getElementById('print-frame');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'print-frame';
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;';
      document.body.appendChild(iframe);
    }
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write(`<!DOCTYPE html><html><head><title>QR - ${sku}</title>
      <style>
        @page { margin: 10mm; }
        body { font-family: Arial, sans-serif; text-align: center; margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 90vh; }
        img { display: block; image-rendering: pixelated; }
        .name { font-size: 13px; font-weight: 600; color: #222; margin-top: 8px; }
      </style></head><body>
      <img src="${dataUrl}" width="200" height="200" />
      <div class="name">${name}</div>
    </body></html>`);
    doc.close();
    iframe.onload = () => { try { iframe.contentWindow.print(); } catch {} };
  } catch {
    alert('Could not generate QR code.');
  }
};

export default QRBox;
